<template>

    <heads>
        <div class="grid grid-cols-2 gap-4">
            <div
                class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg"
            >
                <p class="text-lg font-medium mb-4">List Holidays</p>
                <breeze-table
                    :fields="fields"
                    :items="holidays"
                    :canView="hasRole('View Holiday')"
                >
                    <template #is_applicable_for_faculty="value">
                        <span v-if="value.item.is_applicable_for_faculty">Yes</span>
                        <span v-else>No</span>
                    </template>
                    <template #action="data">
                        <breeze-button v-if="hasRole('Edit Holiday')"  @click.prevent="editHoliday(data.item)">Edit
                        </breeze-button>
                        <breeze-button class="bg-red-500 ml-2" v-if="hasRole('Delete Holiday')"
                                       @click.prevent="deleteHoliday(data.item)">Delete
                        </breeze-button>
                    </template>
                </breeze-table>
                <span v-if="deleteForm.recentlySuccessful" class="text-green-500 mx-4">
                    Holiday deleted.
                </span>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg" v-if="hasRole('Create Holiday')">
                <loading :showLoading="form.processing"/>
                <div :class="{ 'opacity-50': form.processing, 'opacity-100': !form.processing }">
                    <p class="text-lg font-medium mb-4">{{ isEditing ? 'Update' : 'Add' }} Holiday</p>
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Name'"/>
                                <breeze-input required v-model="form.title" class="w-full"/>
                                <breeze-input-error :message="form.errors ? form.errors.title : ''"/>
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'From Date'"/>
                                <breeze-input type="date" required v-model="form.from_date" class="w-full"/>
                                <breeze-input-error :message="form.errors ? form.errors.from_date : ''"/>
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="false" :value="'To Date'"/>
                                <breeze-input type="date" v-model="form.to_date" class="w-full"/>
                                <breeze-input-error :message="form.errors ? form.errors.to_date : ''"/>
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="false" :value="'Is Applicable For Faculty?'"/>
                                <breeze-checkbox v-model="form.is_applicable_for_faculty" :checked="form.is_applicable_for_faculty"/>
                                <breeze-input-error :message="form.errors ? form.errors.is_applicable_for_faculty : ''"/>
                            </div>
                        </div>
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <breeze-button type="button" v-if="isEditing" @click="cancel()" class="bg-red-500 ml-4 hover:bg-red-400">Cancel
                        </breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">
                            Holiday {{ isEditing ? 'Edited' : 'Added' }}.
                        </span>
                        <exception/>
                    </form>
                </div>
            </div>
        </div>
    </heads>
</template>

<script setup>
import Heads from "@/Pages/Heads/Heads";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import ButtonLink from "@/Components/ButtonLink";
import CardHeader from "@/Components/CardHeader";
import {useForm, Link} from "@inertiajs/inertia-vue3";
import BreezeInputError from "@/Components/InputError";
import BreezeButton from "@/Components/Button";
import BreezeCheckbox from "@/Components/Checkbox";
import Loading from "@/Components/Loading";
import Exception from "@/Components/Exception";
import BreezeTable from "@/Components/Table";
import {ref, watch} from "vue";
import {hasRole} from "../../../../Utils/checkPermission";
import {formatDate, formatDateTypeTwo} from "../../../../Utils/Common";

defineProps({
    holidays: Object
});

const form = useForm({
    title: "",
    from_date: "",
    to_date: "",
    is_applicable_for_faculty: true
});

const deleteForm = useForm({});
const isEditing = ref(false);


const fields = [
    {key: "title", label: "Title"},
    {key: "formatted_from_date", label: "From Date"},
    {key: "formatted_to_date", label: "To Date"},
    {key: "is_applicable_for_faculty", label: "For Faculty?"},
    {key: "action", label: "Action"}
];

function submitForm() {
    if (isEditing.value) {
        form.post(route("heads.holiday.update", isEditing.value), {
            preserveScroll: true,
            only:['holidays'],
            onSuccess: () => {
                form.reset('title','from_date','to_date','is_applicable_for_faculty');
                setTimeout(() => {
                    isEditing.value = false;
                }, 2000)

            }
        });
    } else {
        form.post(route("heads.holiday.store"), {
            preserveScroll: true,
            only:['holidays'],
            onSuccess: () => {
                form.reset('title','from_date','to_date','is_applicable_for_faculty');
            }
        });
    }

}

function editHoliday(item) {
    form.title = item.title;
    form.is_applicable_for_faculty = item.is_applicable_for_faculty;
    form.from_date = formatDate(item.from_date);
    form.to_date = item.to_date ? formatDate(item.to_date) : item.to_date;
    isEditing.value = item.id;
}
function deleteHoliday(item) {
    if (confirm('Are you sure to delete this record?')) {
        deleteForm.post(route("heads.holiday.delete",item.id), {
            preserveScroll: true,
            only: ['holidays']
        })
    }
}

function cancel(){
    form.reset('from_date','title','to_date','is_applicable_for_faculty');
    isEditing.value = false;
}
</script>
